define([
	"dojo/_base/lang",
	"dijit/form/Button",
	"csi/def/Action",
	"csi/state/rootStore",
	"./_Plugin",
	"./PluginFactory"
], function(lang, Button, Action, {browserStore}, _Plugin, PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		materialIcon: "zoom_out_map",
		iconClass: "csiActionIcon",
		class: "csi-canvas-full-screen",
		pluginName: "fullScreen",
		title: "ViewFullScreen_TT",

		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ViewFullScreen"
			});
			this.defAction.resolve();
		},

		/**
		 * Only show full screen button if we are not in full screen already
		 */
		canShowPlugin: function() {
			return !browserStore.fullScreen;
		},

		/**
		 * @override
		 * Always enable plugin
		 */
		enablePlugin: function() {
			return true;
		}
	});
});